import locale from './reformationCommentaryLocale.json';

const cache = new Map();
const BASE = `${process.env.PUBLIC_URL}/commentary/reformation${locale.path}`;

export const canonicalBook = book => book === 'zecariah' ? 'zechariah' : book;

export async function loadCommentary(path, signal) {
  if (cache.has(path)) return cache.get(path);
  const response = await fetch(`${BASE}/${path}`, { signal });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const data = await response.json();
  if (data.schemaVersion !== 1) throw new Error('Unsupported commentary format');
  if (locale.language === 'ja' && data.language !== 'ja') throw new Error('Japanese commentary is required');
  cache.set(path, data);
  if (cache.size > 24) cache.delete(cache.keys().next().value);
  return data;
}

export function includesVerse(targets, book, chapter, verse) {
  return targets.some(target => target.book === canonicalBook(book) &&
    (chapter > target.from[0] || (chapter === target.from[0] && verse >= target.from[1])) &&
    (chapter < target.to[0] || (chapter === target.to[0] && verse <= target.to[1])));
}

export function commentaryVerseId(target) {
  if (!(target instanceof Element)) return '';
  const button = target.closest('[data-commentary-verse]');
  if (button) return button.dataset.commentaryVerse;
  const row = target.closest('tr');
  const english = row?.querySelector('td.vn')?.textContent.trim().match(/^(\d+):(\d+)$/);
  if (english) return `${english[1]}-${english[2]}`;
  const block = target.closest('.bible-reading-verse, .gal-verse, .hebrew-verse');
  let marker = block?.querySelector('em') || target.closest('em');
  let span = target.closest('span[id="verse"]');
  while (!marker && span) {
    if (span.previousElementSibling?.matches('em')) marker = span.previousElementSibling;
    span = span.parentElement?.closest('span[id="verse"]');
  }
  if (!marker) return '';
  if (/^\d+-\d+$/.test(marker.id)) return marker.id;
  const match = marker.textContent.trim().match(/^(\d+):(\d+)$/);
  return match ? `${match[1]}-${match[2]}` : '';
}

export function addCommentaryButtons(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('em, td.vn').forEach(marker => {
    const matches = [...marker.textContent.trim().matchAll(/(\d+):(\d+)/g)];
    matches.forEach((match, index) => {
      const button = doc.createElement('button');
      button.type = 'button';
      button.className = 'reformation-verse-button';
      button.dataset.commentaryVerse = `${match[1]}-${match[2]}`;
      const label = `${match[1]}章${match[2]}節の注解を開く`;
      button.setAttribute('aria-label', label);
      button.title = label;
      button.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5.5C9 3.6 5.5 3.6 2.5 5v14c3-1.4 6.5-1.4 9.5.5 3-1.9 6.5-1.9 9.5-.5V5c-3-1.4-6.5-1.4-9.5.5Z"/><path d="M12 5.5v14"/></svg>';
      if (index > 0) {
        const verse = doc.createElement('small');
        verse.textContent = match[2];
        verse.setAttribute('aria-hidden', 'true');
        button.appendChild(verse);
      }
      const block = marker.closest('.bible-reading-verse, .gal-verse, .hebrew-verse');
      if (marker.matches('td')) {
        marker.closest('tr')?.querySelector('td.v')?.appendChild(button);
      } else if (block) {
        block.appendChild(button);
      } else if (marker.nextElementSibling?.matches('span[id="verse"]')) {
        marker.nextElementSibling.after(button);
      } else {
        marker.parentElement.appendChild(button);
      }
    });
  });
  return doc.body.innerHTML;
}
